import {
  compileTemplate,
  extractTemplateVariables,
  IPassengerDto,
  Log,
  SHOWN_PASSENGER_NAMES_LENGTH,
} from "@ryde/shared";

/**
 * Rides-flow rule: recipients are derived from the selected rides rather than picked row by row, so a
 * passenger whose record is inactive must never be messaged. Unrelated to the rides participation
 * filter, which the API applies, and only when a days value was entered.
 */
export const excludeInactivePassengers = (
  passengers: IPassengerDto[],
): IPassengerDto[] => passengers.filter(({ isActive }) => isActive);

export const getPassengersNames = (passengers: IPassengerDto[]): string =>
  passengers
    .slice(0, SHOWN_PASSENGER_NAMES_LENGTH)
    .map(e => `${e.firstName} ${e.lastName}`)
    .join(", ");

export const getPreviewMessage = (
  message: string,
  passengers: IPassengerDto[],
): string => {
  const passenger = passengers?.[0];

  if (message && passenger) {
    try {
      return compileTemplate(message, passenger);
    } catch (err) {
      Log.error(`Error compiling template: ${message}`, err);

      const invalidKeys = extractTemplateVariables(message)?.filter(
        key => !(key in passenger),
      );

      if (invalidKeys?.length > 0) {
        Log.error(`Invalid template: ${invalidKeys.join(", ")}`);
      }
    }
  }

  return message ?? "";
};
